import { render, staticRenderFns } from "./LeadsPage.vue?vue&type=template&id=00a782e6&scoped=true&"
import script from "./LeadsPage.vue?vue&type=script&lang=js&"
export * from "./LeadsPage.vue?vue&type=script&lang=js&"
import style0 from "./LeadsPage.vue?vue&type=style&index=0&id=00a782e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a782e6",
  null
  
)

export default component.exports